// extracted by mini-css-extract-plugin
export default {"header-container":"Store_header-container__utLgD","flex":"Store_flex__0YAY-"};